/* eslint-disable no-alert */
/* eslint-disable no-unused-vars */
/* eslint-disable camelcase */
import React from 'react';
import PropTypes from 'prop-types';
import {
  Button, Card, CardBody, CardFooter, CardHeader, Col, Form, FormGroup, Input, Label, Row,
} from 'reactstrap';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { createTheme } from '../../actions/themes';
import { resetError } from '../../actions/errors';
import PinModal from '../../components/pin';
import validateAnimationPoints from './validate';

class ThemeNew extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      submitted: false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleFileChange = this.handleFileChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.requestSubmit = this.requestSubmit.bind(this);
    this.failedSubmit = this.failedSubmit.bind(this);
  }

  handleChange(e, name) {
    const { value } = e.target;
    this.setState({ [name]: value });
  }

  handleFileChange(e, name) {
    const { files } = e.target;
    this.setState({ [name]: files[0] });
  }

  requestSubmit(e) {
    e.preventDefault();
    const { animation_points } = this.state;
    const result = validateAnimationPoints(animation_points);
    if (result.valid) {
      this.setState({
        submitted: true,
        animation_points_error: false,
      });
    } else {
      alert(result.message);
      this.setState({
        submitted: false,
        animation_points_error: true,
      });
    }
  }

  failedSubmit() {
    this.setState({
      submitted: false,
    });
  }

  handleSubmit() {
    const { createThemeAction, goToList, resetErrorAction } = this.props;
    resetErrorAction();
    const {
      title,
      link,
      animation_points,
      filename,
      category,
      device,
      type,
      comments,
      credit,
      credit_link,
      premium,
    } = this.state;
    const body = {
      title,
      link,
      animation_points: animation_points ? JSON.parse(animation_points) : undefined,
      filename,
      category,
      device,
      type,
      comments,
      credit,
      credit_link,
      premium,
    };
    Object.keys(body).forEach(key => body[key] === undefined && delete body[key]);
    createThemeAction({ body: JSON.stringify(body) }).then(() => {
      goToList();
    });
  }

  render() {
    const {
      title,
      link,
      animation_points,
      animation_points_error,
      filename,
      category,
      device,
      type,
      comments,
      credit,
      credit_link,
      submitted,
    } = this.state;
    const { goToList } = this.props;
    return (
      <div className="animated fadeIn">
        {
          submitted
          && <PinModal successSubmit={this.handleSubmit} failedSubmit={this.failedSubmit} />
        }
        <Row>
          <Col lg={6}>
            <Card>
              <Form onSubmit={e => this.requestSubmit(e)} encType="multipart/form-data">
                <CardHeader>
                  <strong>
                    {'New theme'}
                  </strong>
                </CardHeader>
                <CardBody>
                  <FormGroup>
                    <Label htmlFor="title">Title</Label>
                    <Input
                      id="title"
                      type="text"
                      placeholder="Enter Title"
                      invalid={submitted && title === ''}
                      onChange={e => this.handleChange(e, 'title')}
                      required
                    />
                  </FormGroup>
                  <FormGroup>
                    <Label htmlFor="link">Link</Label>
                    <Input
                      id="link"
                      type="text"
                      placeholder="Enter Link"
                      invalid={submitted && link === ''}
                      onChange={e => this.handleChange(e, 'link')}
                      required
                    />
                  </FormGroup>
                  <FormGroup>
                    <Label htmlFor="animation_points">Animation points</Label>
                    <Input
                      id="animation_points"
                      type="textarea"
                      placeholder="Enter Animation points"
                      invalid={(submitted && animation_points === '') || animation_points_error}
                      onChange={e => this.handleChange(e, 'animation_points')}
                      required
                      rows="10"
                    />
                  </FormGroup>
                  <FormGroup>
                    <Label htmlFor="filename">Filename</Label>
                    <Input
                      id="filename"
                      type="text"
                      placeholder="Enter Filename"
                      invalid={submitted && filename === ''}
                      onChange={e => this.handleChange(e, 'filename')}
                      required
                    />
                  </FormGroup>
                  <FormGroup>
                    <Label htmlFor="category">Category</Label>
                    <Input
                      id="category"
                      type="text"
                      placeholder="Enter Category"
                      invalid={submitted && category === ''}
                      onChange={e => this.handleChange(e, 'category')}
                      required
                    />
                  </FormGroup>
                  <FormGroup>
                    <Label htmlFor="device">Device</Label>
                    <Input
                      id="device"
                      type="text"
                      placeholder="Enter Device"
                      invalid={submitted && device === ''}
                      onChange={e => this.handleChange(e, 'device')}
                      required
                    />
                  </FormGroup>
                  <FormGroup>
                    <Label htmlFor="type">Type</Label>
                    <Input
                      id="type"
                      type="text"
                      placeholder="Enter Type"
                      invalid={submitted && type === ''}
                      onChange={e => this.handleChange(e, 'type')}
                      required
                    />
                  </FormGroup>
                  <FormGroup>
                    <Label for="premium">Premium</Label>
                    <Input
                      type="select"
                      name="premium"
                      id="premium"
                      onChange={e => this.handleChange(e, 'premium')}
                    >
                      <option>true</option>
                      <option>false</option>
                    </Input>
                  </FormGroup>
                  <FormGroup>
                    <Label htmlFor="comments">Comments</Label>
                    <Input
                      id="comments"
                      type="text"
                      placeholder="Enter Comments"
                      invalid={submitted && comments === ''}
                      onChange={e => this.handleChange(e, 'comments')}
                    />
                  </FormGroup>
                  <FormGroup>
                    <Label htmlFor="credit">Credit</Label>
                    <Input
                      id="credit"
                      type="text"
                      placeholder="Enter Credit"
                      invalid={submitted && credit === ''}
                      onChange={e => this.handleChange(e, 'credit')}
                    />
                  </FormGroup>
                  <FormGroup>
                    <Label htmlFor="credit_link">Credit Link</Label>
                    <Input
                      id="credit_link"
                      type="text"
                      placeholder="Enter Credit Link"
                      invalid={submitted && credit_link === ''}
                      onChange={e => this.handleChange(e, 'credit_link')}
                    />
                  </FormGroup>
                </CardBody>
                <CardFooter>
                  <Button type="submit" size="sm" color="primary">Create</Button>
                  {' '}
                  <Button onClick={() => goToList()} size="sm" color="danger">Cancel</Button>
                </CardFooter>
              </Form>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

ThemeNew.propTypes = {
  createThemeAction: PropTypes.func.isRequired,
  goToList: PropTypes.func.isRequired,
  resetErrorAction: PropTypes.func.isRequired,
};

const mapDispatchToProps = dispatch => bindActionCreators({
  createThemeAction: body => createTheme(body),
  goToList: () => push('/themes'),
  resetErrorAction: () => resetError(),
}, dispatch);

export default connect(
  null,
  mapDispatchToProps,
)(ThemeNew);
